import PropTypes from "prop-types";
import { Container } from '@/components/ui/container';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

const FrameComponent7 = ({ className = "" }) => {
  return (
    <div className={cn("relative w-full h-[578px] text-center text-4xl", className)}>
      <img
        className="absolute top-0 left-0 w-full h-full object-cover"
        loading="lazy"
        alt=""
        src="/Rectangle3844.png"
      />
      <Container>
        <Stack spacing="lg" align="center" className="absolute top-[254px] left-[202px] w-[1084px] max-w-full">
          <Heading level="h1" className="self-stretch text-5xl md:text-6xl font-bold text-foreground">
            Hello, NewZenAlpha!
          </Heading>
          <Text variant="muted" size="lg" className="w-[949px] max-w-full text-xl font-semibold">
            Welcome to AI Evaluator, NewGenAlpha! Your journey towards smarter and more efficient hiring begins here. Let's redefine the future together!
          </Text>
        </Stack>
      </Container>
      <header className="absolute top-7 left-15 w-[1320px] max-w-full flex flex-row items-center justify-between text-left text-5xl">
        <Inline spacing="xl" align="center" className="w-[945px] justify-between">
          <a href="/" className="block">
            <img src="aieval.png" alt="Logo" className="h-8" />
          </a>
          <nav className="hidden md:flex flex-row items-center justify-center py-2.5 gap-7.5 text-xl text-accent-foreground font-medium">
            <a href="/" className="hover:text-foreground transition-colors">Home</a>
            <a href="/about" className="hover:text-foreground transition-colors">About</a>
            <a href="/faq" className="hover:text-foreground transition-colors">FAQ</a>
            <a href="/testimonial" className="hover:text-foreground transition-colors">Testimonial</a>
            <a href="/contact" className="hover:text-foreground transition-colors">Contact</a>
          </nav>
        </Inline>
        <div className="h-[59px] flex flex-row items-center justify-start gap-2.25 text-center text-xl">
          <div className="self-stretch w-15 rounded-full bg-muted" />
          <a href="/" className="font-medium">NewZenAlpha</a>
        </div>
      </header>
    </div>
  );
};

FrameComponent7.propTypes = {
  className: PropTypes.string,
};

export default FrameComponent7;
